// Web addresses for brand, campaign and product pages (/shop?brand=…,
// /offers/…, /products/…): lowercase letters, numbers and single hyphens —
// the API's rule.

/** Same rule the API uses to make a web address from a name. */
export const slugFromName = (name: string): string =>
    name
        .normalize("NFKD")
        .replace(/[^\x20-\x7e]/g, "")
        .replace(/[^\w\s-]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[-\s_]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 110);

/** Tidy what's typed: lowercase, spaces become hyphens, other symbols go. */
export const cleanSlugInput = (value: string): string =>
    value
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(/[^a-z0-9-]/g, "");

export const SLUG_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;

// Words left out of a product's address made from its name.
const FILLER = new Set(["for", "with", "and", "the", "of", "in", "a", "an", "to", "&"]);
const PRODUCT_SLUG_AUTO_MAX = 50;
export const PRODUCT_SLUG_MAX = 80;

/**
 * A product's web address made from its name — the API's _product_slug
 * (app/services/products.py): bracketed bits and filler words dropped, cut
 * at a word break by 50 characters. "SmartHeart Kitten Chicken Fish Egg &
 * Milk 1.1kg" → "smartheart-kitten-chicken-fish-egg-milk-1-1kg".
 */
export const productSlugFromName = (name: string): string => {
    const ascii = (name || "")
        .normalize("NFKD")
        .replace(/[^\x20-\x7e]/g, "")
        .replace(/\([^)]*\)|\[[^\]]*\]/g, " ");
    const words = ascii
        .split(/\s+/)
        .filter((w) => w && !FILLER.has(w.toLowerCase().replace(/^[.,;:!?]+|[.,;:!?]+$/g, "")));
    let value = words
        .join(" ")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    if (value.length > PRODUCT_SLUG_AUTO_MAX) {
        const cut = value.lastIndexOf("-", PRODUCT_SLUG_AUTO_MAX);
        value = cut > 0 ? value.slice(0, cut) : value.slice(0, PRODUCT_SLUG_AUTO_MAX);
    }
    return value.replace(/^-+|-+$/g, "");
};
